import { useState } from "react";
import "../Insights.scss";
import BarChart from "../../Charts/BarChart";
import images from "../../../assets/Icons/Icons";
import AverageTimeCard from "./AvergeTimeCard";
import { StatCard } from "./LearnersCreating";
import EmotionalTrends from "../Admin/Cards/EmotionalTrends";
import EmotionalTrendsChart from "./EmotionalTrends";
import { SectionLoader } from "../../Loader/sectionLoader";
import NoDataScreen from "../../EmptyScreen/EmptyScreen";
import { trackEvent } from "../../../mixpanel";

const HowTheyDoing = ({
  data,
  Admin,
  name,
  isClassroom,
  loading,
}: {
  data?: any;
  Admin?: boolean;
  name?: string;
  isClassroom?: boolean;
  loading?: boolean;
}) => {
  const [open, setOpen] = useState(false);

  const toggleOpen = () => {
    const willBeOpen = !open;
    if (willBeOpen) {
      trackEvent("SECTION_EXPANDED_TEACHER", {
        section: Admin ? "How Are They Doing" : "How Are They Engaging",
        view: isClassroom ? "Classroom" : "Student",
      });
    }
    setOpen(willBeOpen);
  };

  const avgTimeData = data?.data?.totalTimeStats;
  const isAvgTimeEmpty = !avgTimeData || Object.keys(avgTimeData).length === 0;

  return (
    <section className="insight-section">
      <header onClick={toggleOpen} className="section-header">
        <h3>{!Admin ? "HOW ARE THEY ENGAGING" : "HOW ARE THEY DOING?"}</h3>
        <img
          src={open ? images.upIocn : images.downIcon}
          width={44}
          height={44}
        />
      </header>

      {open &&
        (loading ? (
          <SectionLoader />
        ) : (
          <>
            <div className="grid three">
              <div className="cards">
                <h5>Emotional Trends</h5>

                <EmotionalTrendsChart chartData={data?.data} />
              </div>

              {/* Kids to talk */}
              {isClassroom && (
                <div className="cards">
                  <h5>Kids who want an adult's help</h5>
                  {data?.data?.mindfulnessSnapshot?.TalkRequest?.students
                    ?.length === undefined && <NoDataScreen />}
                  <div className="names-grid">
                    {data?.data?.mindfulnessSnapshot?.TalkRequest?.students?.map(
                      (name: any) => (
                        <span key={name} className="name">
                          {name}
                        </span>
                      )
                    )}
                  </div>
                </div>
              )}

              {isClassroom && (
                <div className="cards">
                  <h5>Kids hesitant to get an adult's help</h5>
                  {data?.data?.mindfulnessSnapshot?.NoHelp?.students?.length ===
                    undefined && <NoDataScreen />}

                  <div className="names-grid">
                    {data?.data?.mindfulnessSnapshot?.NoHelp?.students?.map(
                      (name: any) => (
                        <span key={name} className="donttalkname">
                          {name}
                        </span>
                      )
                    )}
                  </div>
                </div>
              )}

              <div className="cards">
                <h5>Average time to complete stories</h5>
                {isAvgTimeEmpty ? (
                  <NoDataScreen />
                ) : (
                  <AverageTimeCard data={data?.data?.totalTimeStats} />
                )}
              </div>
            </div>
          </>
        ))}
    </section>
  );
};

export default HowTheyDoing;
